// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JGLvb","box":"styles_box__ibnGc","title":"styles_title__Y3Nqr","icon":"styles_icon__GhXGH","icone":"styles_icone__ALeov"};